<div class="snackbar {{show}}">{{message}}</div>
<section class="main">
    <div class="hero-left">
            <img src="../../assets/img/Dress_display.jpg">
        <div class="text-block">
            <h2>LIMITED EDITION</h2>
            <h1>New Arrival <br> The Best Choice</h1>
            <a href="/categories/1">Shop the Category</a>
        </div>
    </div>
    <div class="hero-right">
        <img src="../../assets/img/model-2.png">
        <div class="text-block">
            <h1>Buy Less <br> Wear More</h1>
        </div>
    </div>
</section>

<section class="breaker">
<div class="bar"><p>Free Shipping on orders above 10,000 pkr</p></div>
</section>

<section class="display-block">
    <div class="details">
        <h2>Collection WS 2021</h2>
        <h1>Wedding season is here <br> starting <span>7000 pkr</span></h1>
        <a href="/categories/1"><button>Go Renting</button></a>
    </div>
    <div class="loader" *ngIf="isLoading1">
        <mat-spinner style="margin:0 auto;" *ngIf="isLoading1"></mat-spinner>
    </div>
    <div class="item-block1" *ngIf="!isLoading1">
        <div class="d-image1">
            <img src="{{clothes1[0].pic_urls[0]}}" >
            <div class="buttons">
                <button (click)="openDialog(clothes1[0])">Add to Cart</button>
                <button (click)="navigate(clothes1[0]._id)">View Details</button>
            </div>
        </div>
        
        <div class="dress-detail">
            <p class="cat">Bridal</p>
            <p class="nam">{{clothes1[0].dress_name}}</p>
            <p class="price"><del>{{clothes1[0].basic_rent+500}} pkr</del><b> {{clothes1[0].basic_rent+500}} pkr</b></p>
        </div>
    </div>
    <div class="item-block2" *ngIf="!isLoading1">
        <div class="d-image2">
            <img src="{{clothes1[3].pic_urls[0]}}">
            <div class="buttons">
                <button (click)="openDialog(clothes1[3])">Add to Cart</button>
                <button (click)="navigate(clothes1[3]._id)">View Details</button>
            </div>
        </div>
        <div class="dress-detail">
            <p class="cat">Bridal</p>
            <p class="nam">{{clothes1[3].dress_name}}</p>
            <p class="price"><del>{{clothes1[3].basic_rent+500}} pkr</del><b> {{clothes1[3].basic_rent}} pkr</b></p>
        </div>
    </div>
</section>

<br>
<br>

<section class="display-block">
    <div class="loader" *ngIf="isLoading2">
        <mat-spinner style="margin:0 auto;" *ngIf="isLoading2"></mat-spinner>
    </div>
    <div class="item-block1" *ngIf="!isLoading2">
        <div class="d-image3">
            <img src="{{clothes2[0].pic_urls[0]}}">
        </div>
        <div class="buttons">
            <button (click)="openDialog(clothes2[0])">Add to Cart</button>
            <button (click)="navigate(clothes2[0]._id)">View Details</button>
        </div>
        <div class="dress-detail">
            <p class="cat">Suits</p>
            <p class="nam">{{clothes2[0].dress_name}}</p>
            <p class="price"><del>{{clothes2[0].basic_rent+500}} pkr</del><b> {{clothes2[0].basic_rent}} pkr</b></p>
        </div>
    </div>
    <div class="item-block2" *ngIf="!isLoading2">
        <div class="d-image4">
            <img src="{{clothes2[3].pic_urls[0]}}">
        </div>
        <div class="buttons">
            <button (click)="openDialog(clothes2[3])">Add to Cart</button>
            <button (click)="navigate(clothes2[3]._id)">View Details</button>
        </div>
        <div class="dress-detail">
            <p class="cat">Suits</p>
            <p class="nam">{{clothes2[3].dress_name}}</p>
            <p class="price"><del>{{clothes2[3].basic_rent+500}} pkr</del><b> {{clothes2[3].basic_rent}} pkr</b></p>
        </div>
    </div>
    <div class="details">
        <h2>New Arrival 2021</h2>
        <h1>Dazzle Everyone <br> starting <span>2000 pkr</span></h1>
        <a href="/categories/3"><button>Go Renting</button></a>
    </div>
</section>

<hr>

<section class="media" >
<div class="sm-links">
    <a href="https://www.facebook.com/thezebaish"><img class="logo" src="/../../assets/img/facebook.png">Facebook</a>
    <a href="https://www.instagram.com/thezebaishofficial/"><img class="logo" src="/../../assets/img/logo-instagram.png">Instagram</a>
    <a href="https://twitter.com/TheZebaish"><img class="logo" src="/../../assets/img/logo-twitter.png">Twitter</a>
    <a href="https://www.youtube.com/channel/UCWBFR9fjHcdxgauozePem4Q"><img class="logo" src="/../../assets/img/PngItem_200678.png">YouTube</a>
</div>
<div class="blog1">
    <div class="content1" style="background-image: url('/../../assets/img/bg1.png');">
        <p>ZEBAISH FASHION</p> 
        <h1>New Way <br>To Live Life</h1>
        <a target="_blank" href="https://www.hausvoneden.com/lifestyle/kleidung-mieten-statt-neukauf-der-guide-zum-kleiderschrank-make-over/"><button>Learn More</button></a>
    </div>
    <div class="content1" style="background-image: url('/../../assets/img/bg.png'); margin-right: 1em;">
        <p>ZEBAISH FASHION</p> 
        <h1>Simplify <br>Life</h1>
        <a target="_blank" href="https://kerinmarketing.com/2020/02/26/why-buy-clothes-rent-them-instead/"><button>Learn More</button></a>
    </div>
</div>
<div class="blog2">
    <div class="content1" style="background-image: url('/../../assets/img/c1.jpeg'); background-position: center;">
        <p>ZEBAISH FASHION</p> 
        <h1>Renting Is The <br>New Buying</h1>
        <a target="_blank" href="https://www.trustedclothes.com/blog/2019/01/30/9-benefits-of-renting-clothes/"><button>Learn More</button></a>
    </div>
    <div class="content2" style="background-image: url('/../../assets/img/c2.jpg');">
        <p>ZEBAISH FASHION</p> 
        <h1>Save Money <br> Save Enviornment</h1>
        <a target="_blank" href="https://www.channelnewsasia.com/news/commentary/rent-luxury-brands-clothing-designer-styles-environment-friendly-10599370"><button>Learn More</button></a>
    </div>
    <div class="content2" style="background-image: url('/../../assets/img/c3.jpg');">
        <p>ZEBAISH FASHION</p> 
        <h1>Always On Budget <br> We Got You Covered</h1>
        <a target="_blank" href="https://www.whowhatwear.com/benefits-of-renting-clothes/slide8"><button>Learn More</button></a>
    </div>
</div>
</section>

<section class="info">
    <div class="info-block">
        <img class="info-icon" src="/../../assets/img/ICON 1.png">
        <h2>Home Delivery</h2>
        <p>Providing doorstep service</p>
    </div>
    <hr class="lines">
    <div class="info-block">
        <img class="info-icon" src="/../../assets/img/ICON 2.png">
        <h2>Easy Returns</h2>
        <p>Hassle less return policy</p>
    </div>
    <hr class="lines">
    <div class="info-block">
        <img class="info-icon" src="/../../assets/img/ICON 3.png">
        <h2>Secured Payment</h2>
        <p>Secured and Easy Payment Methods</p>
    </div>
    <hr class="lines">
    <div class="info-block">
        <img class="info-icon" src="../../assets/img/ICON 4.png">
        <h2>Customer Service</h2>
        <p>Always there to help you out.</p>
    </div>
    <hr class="lines">
</section>

<section class="sub-mail">
<div class="main-sub">
    <div class="sub-content">
        <h2>Let's Stay In Touch</h2>
        <p>Enjoy 15% off on your first order after you join our mailing list</p>
        <div>
            <input type="text" name="email" [(ngModel)]="email" placeholder="Enter Email Address" class="email">
            <button (click)="mailingList()">Subscribe</button>
        </div>
        <p>We respect your privacy, so we never share your info.</p>
    </div>
</div>
</section>